module.exports = __webpack_public_path__ + "static/media/pridefit_01.b9c65d0d.jpg";